// Template Generated by DataExtraction.py at 1716507313
        
import RDIEn3 from "../../Forms/RDI/RDI_En3.png";
import RDIEn3Labels from "../../Labels/RDI/RDI_En3.json";
import RDIFr3 from "../../Forms/RDI/RDI_Fr3.png";
import RDIFr3Labels from "../../Labels/RDI/RDI_Fr3.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? RDIFr3Labels : RDIEn3Labels;
    const formImage = isFrench ? RDIFr3 : RDIEn3;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    // Drawing the form
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? RDIFr3Labels : RDIEn3Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    